import { Component, OnInit ,Input} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// import {Familiar} from '../../../models/familiar';
import {Cliente} from '../../../models/cliente';
import {generalService} from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'my-ubicacion-addedit',
  styles: [],
  templateUrl: 'ubicacion-addedit.component.html',
  providers: [generalService]
})

export class UbicacionAddEditComponent implements OnInit {
 
 @Input() ubicacion:any;
  cliente:Cliente;
  ubicacionForm: FormGroup;
  titulo = "Agregar";
  list: any;


  constructor(
    private formBuilder: FormBuilder, 
    private _generalService: generalService, 
    public dialog: MatDialog, 
    public dataService: DataService, 
    private route: ActivatedRoute) 
  { 
    this.ubicacion = new Object();
    this.cliente = new Cliente();
    this.list = new Object();  
  }

  ngOnInit() {
    this.buildForm();
    this.getInit(this.dataService.idCliente);

    if(this.dataService.isUpdate){
      this.titulo = "Editar";
      this.ubicacion.idUbicacion = this.dataService.id;
      this.getUbicacion(this.ubicacion.idUbicacion);
    }
  }

  getInit(id:any){
    this._generalService.metodoCall(`ubicacion/getInit/${id}`).subscribe(
      result => {            
        let res = JSON.parse(result);        
        this.cliente.Nombre = res.Table[0].NAME;
       
        // this.list.State = res.Table3;
        // this.list.City = res.Table4;
        },
      error => {
        console.log(<any>error);
      }
    );
  }

   // getBitacora(id:any){

   // }

  getUbicacion(id:any){
      this._generalService.metodoCall(`ubicacion/consultarUbicacion/${id}`).subscribe(
        result => {
          let res = JSON.parse(result);// this.familiar = JSON.parse(result.replace("[", "").replace("]", ""));     
          this.ubicacion = res[0];
           // let fechas = this.familiar.fecha.split("/");
          // this.familiar.fecha = new Date(fechas[2], fechas[1] - 1, fechas[0]);     
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  buildForm() {
    this.ubicacionForm = this.formBuilder.group({
      NombreCliente: [{disabled:true}],//this.formBuilder.control(null),
      nombreUbicacion: this.formBuilder.control(null, [Validators.required, Validators.maxLength(100)]),
      comentario: this.formBuilder.control(null, [Validators.required, Validators.maxLength(100)]),
      direccion: this.formBuilder.control(null, [Validators.required, Validators.maxLength(100)]),
      correo: this.formBuilder.control(null, [Validators.required, Validators.maxLength(100)]),
      nombre: this.formBuilder.control(null, [Validators.required, Validators.maxLength(100)]),
    });
    this.ubicacionForm.get('NombreCliente').disable();
  }

  cerrarModal(){
    this.dataService.dialogRef.close();
  }

  createUbicacion(){
    this._generalService.metodoCallParams(this.ubicacion, "ubicacion/agregarUbicacion").subscribe(
          result => {
            this._generalService.toastCall(result.message);
          },
          error => {
            console.log(<any>error);
          }
      ); 
  }

  updateUbicacion(){
    this._generalService.metodoCallParams(this.ubicacion, "ubicacion/actualizarUbicacion").subscribe(
          result => {
            this._generalService.toastCall(result.message);
          },
          error => {
            console.log(<any>error);
          }
      ); 
  }

  onSubmit() {
    this.ubicacion.idCliente = this.dataService.idCliente; 
    if(this.dataService.isUpdate)
      this.updateUbicacion();
    else
      this.createUbicacion();
    this.cerrarModal();
  }
}


// WEBPACK FOOTER //
// ./src/app/cliente/ubicacion/agregar-editar/ubicacion-addedit.component.ts